/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { createOrUpdateAlbumModelSchema } from "../createOrUpdateAlbumModelSchema.ts";
import { guidCreatedOrUpdatedEntityModelSchema } from "../guidCreatedOrUpdatedEntityModelSchema.ts";
import { z } from "zod";

export const putApiAlbumsIdPathParamsSchema = z.object({
    "Id": z.string().uuid().describe("Идентификатор альбома.")
    })

/**
 * @description Идентификатор редактируемого альбома
 */
export const putApiAlbumsId200Schema = z.lazy(() => guidCreatedOrUpdatedEntityModelSchema)

/**
 * @description Ошибка валидации запроса | Неправильный запрос
 */
export const putApiAlbumsId400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const putApiAlbumsId401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const putApiAlbumsId403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Альбом не найден | Авторы не найдены
 */
export const putApiAlbumsId404Schema = z.unknown()

/**
 * @description Внутренняя ошибка сервера
 */
export const putApiAlbumsId500Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Тело запроса.
 */
export const putApiAlbumsIdMutationRequestSchema = z.lazy(() => createOrUpdateAlbumModelSchema).describe("Тело запроса.")

export const putApiAlbumsIdMutationResponseSchema = z.lazy(() => putApiAlbumsId200Schema)